export default function capitalize(word: string): string {
    return word.replace(/^./, word[0].toUpperCase());
}
